import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-counter-item',
  templateUrl: './counter-item.component.html',
  styleUrls: ['./counter-item.component.scss']
})
export class CounterItemComponent implements OnInit {

  @Input() number: number;

  constructor() { }

  ngOnInit() {
  }

}
